<template>
    <ul class="nav nav-pills">
        <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                <strong>{{currentCycleTitle}}</strong> ( {{FormatDate(cycleStartDate)}} - {{FormatDate(cycleEndDate)}} )<span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <template v-for="(cycle, index) in cycles">
                    <template v-if="index==0">
                        <li>
                            <a @click.prevent.self="SetCycle(cycle)">
                                <strong class="text-primary">Next</strong><br />
                                {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                            </a>
                        </li>
                        <li class="divider"></li>
                    </template>

                    <template v-if="index==1">
                        <li>
                            <a @click.prevent.self="SetCycle(cycle)">
                                <strong class="text-danger"> Current</strong><br />
                                {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                            </a>
                        </li>
                        <li class="divider"></li>
                    </template>

                    <template v-if="index>1">
                        <li>
                            <a @click.prevent.self="SetCycle(cycle)">
                                {{FormatDate(cycle.startDate)}} - {{FormatDate(cycle.endDate)}}
                            </a>
                        </li>
                    </template>
                </template>
            </ul>
        </li>
    </ul>
</template>
<script>
    import Dal from './../../../scripts/dataaccess';
    import Formatter from "../../corecontrols/formatters/Formatter";


    export default {
        props: ['wardId', 'value'],
        data: function () {
            return {
                cycles: [],
                cycleStartDate: undefined,
                cycleEndDate: undefined,
                currentCycleTitle: "",
            }
        },
        mounted: function () {
            this.Load();
        },
        watch: {
            'wardId': function () { this.Load() }
        },
        methods: {
            Load: function () {
                console.log("Loading Cycles for Ward ", this.wardId)
                if (this.wardId != null) {
                    
                    var dal = new Dal();

                    dal.GetWardCycles(this.wardId).then(cycles => {
                        var sortedCycles = cycles.sort((n1, n2) => {
                            if (n1.startDate > n2.startDate) return -1;
                            else if (n1.startDate < n2.startDate) return 1;
                            else return 0;
                        });

                        this.cycles = sortedCycles;

                        if (!this.cycleStartDate || !this.cycleEndDate) {
                            //this.cycleStartDate = sortedCycles[1].startDate;
                            //this.cycleEndDate = sortedCycles[1].endDate;
                            //this.currentCycleTitle = "Current Cycle"
                            this.SetCycle(sortedCycles[1])
                        }
                    });
                }
            },
            FormatDate: function (dt) {
                return Formatter.FormatDate(dt);
            },
            SetCycle: function (cycle) {

                this.currentCycleTitle = this.cycles.indexOf(cycle) == 0 ? "Next Cycle" : this.cycles.indexOf(cycle) == 1 ? "Current Cycle" : " Cycle";

                this.cycleStartDate = cycle.startDate;
                this.cycleEndDate = cycle.endDate;

                this.$props.value = cycle;
                this.$emit('input', cycle);
            }
        }
    }
</script>














// WEBPACK FOOTER //
// CycleSelector.scp.html?27c87766